import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Handle } from 'src/app/handle';
import { MatDialogRef,MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';

const DATA = [
  { descripcion: 'Un registro se contacta _ veces por día', control: 'XDIA1' },
  { descripcion: 'Si en un día no es contactado, se marcara de nuevo _ días después.', control: 'XDIA2' },
  { descripcion: 'Si falla la opción anterior se marca _ días después', control: 'XDIA3' },
  { descripcion: 'Si la anterior falla se desecha el registro y se marca _ meses después.', control: 'MESES' },
  // { descripcion: 'Si el cliente rechaza oferta se marcará _ Meses después', control: 'RECHAZO' },
  //{ descripcion: 'Se programa un SMS automático de Bienvenida para ser enviado _ horas después', control: 'BIENVENIDA' },
  //{ descripcion: 'Se programa un SMS automático de beneficios para ser enviado _ horas después', control: 'BENEFICIOS' },
  //{ descripcion: 'Se programa Recordatorio de Facturación _ días después', control: 'RECORDATORIO' },
  //{ descripcion: 'Se programa campaña de primera factura _ días después ', control: 'PRIMERAFACTURA' },

];

const EDATA = [
  { descripcion: 'Si en un día no es contactado, se marcara de nuevo _ días después.', control: 'EXDIA2' },
  { descripcion: 'Si falla la opción anterior se marca _ días después', control: 'EXDIA3' },
];

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss']
})
  
export class ConfiguracionComponent implements OnInit {

  displayedColumns: string[] = ['descripcion', 'control'];
  dataSource = DATA;
  dataSource1 = EDATA;

  constructor(
    private snackbar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public Handle: Handle,
    private localsave: LocalSaveService,
    private dialogRef: MatDialogRef<ConfiguracionComponent>,
    public tabController: ComponentTabController,
  ) { }

  ngOnInit() {
   // this.spinner.show();
    this.gateway.get('obtenerregla', {IDAREA:this.localsave.get('usuarioPGV').IDAREA}).then((result) => { 

      let aux:any = result;
      this.grupoVal.controls['XDIA1'].setValue(aux.rows[0].valor);
      this.grupoVal.controls['XDIA2'].setValue(aux.rows[1].valor);
      this.grupoVal.controls['XDIA3'].setValue(aux.rows[2].valor);
      this.grupoVal.controls['MESES'].setValue(aux.rows[3].valor);
      this.grupoVal.controls['RECHAZO'].setValue(aux.rows[4].valor);

      this.grupoVal.controls['EXDIA2'].setValue(aux.rows[5] ? aux.rows[5].valor : 1);
      this.grupoVal.controls['EXDIA3'].setValue(aux.rows[6] ? aux.rows[6].valor : 1);
      
     /// this.spinner.hide();
      // result[0].forEach(element => {this.grupoVal.controls[element.NOMBRE].setValue(element.VALOR)
      //   this.grupoVal.controls[element.NOMBRE].setValue(element.VALOR); 
      // });
    });
  }

  tabChanged(event) {
    // alert(event.index)
	}

  guardar() { 
    let RECORD = {
      IDAREA:this.localsave.get('usuarioPGV').IDAREA,
      IDADMIN:this.localsave.get('usuarioPGV').IDU,
      XDIA1: parseInt(this.grupoVal.controls.XDIA1.value),
      XDIA2: parseInt(this.grupoVal.controls.XDIA2.value),
      XDIA3: parseInt(this.grupoVal.controls.XDIA3.value),
      MESES: parseInt(this.grupoVal.controls.MESES.value),
      RECHAZO: parseInt(this.grupoVal.controls.RECHAZO.value),

      EXDIA2: parseInt(this.grupoVal.controls.EXDIA2.value),
      EXDIA3: parseInt(this.grupoVal.controls.EXDIA3.value),
    }

    this.spinner.show();
    this.gateway.save('modificarregla', RECORD).then((result) =>{
      this.dialogRef.close();
      this.spinner.hide();
      this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', {duration: 3000,});
    }
    ).catch(function(e) {
    });

  }

  onNoClick() { 
    this.dialogRef.close();
  }

  grupoVal = new FormGroup({

    // FASE CONTACTO
    XDIA1: new FormControl('', [Validators.compose([Validators.required, Validators.min(1),Validators.pattern('[1-9]+')])]),
    XDIA2: new FormControl('',[Validators.compose([Validators.required, Validators.min(1),Validators.pattern('[1-9]+')])]),
    XDIA3: new FormControl('',[Validators.compose([Validators.required, Validators.min(1),Validators.pattern('[1-9]+')])]),
    MESES: new FormControl('',[Validators.compose([Validators.required, Validators.min(0),Validators.pattern('[0-9]+')])]),
    RECHAZO: new FormControl('',[Validators.compose([Validators.required, Validators.min(0),Validators.pattern('[0-9]+')])]),

    // FASE ENTREVISTA
    EXDIA2: new FormControl('',[Validators.compose([Validators.required, Validators.min(1),Validators.pattern('[1-9]+')])]),
    EXDIA3: new FormControl('',[Validators.compose([Validators.required, Validators.min(1),Validators.pattern('[1-9]+')])])
  });

}
